import { render, staticRenderFns } from "./InvalidToken.vue?vue&type=template&id=ba641e9a"
import script from "./InvalidToken.vue?vue&type=script&lang=js"
export * from "./InvalidToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports